<template>
    <v-container grid-list-xl v-if="this.$store.state.signedIn">
        <v-flex xs12 v-for="(entry, key) in changelog" :key="key">
            <v-card>
                <v-toolbar dark flat color="secondary">
                    <v-toolbar-title :style="$store.state.textFormatting.headers">
                        {{ entry.date }}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <h1 v-if="entry.components" :style="$store.state.textFormatting.main"> <b :style="$store.state.textFormatting.main"> Solution Components and Versions </b> </h1>
                    <ul v-if="entry.components">
                        <li v-for="change in entry.components" :key="change" :style="$store.state.textFormatting.main"><h3 :style="$store.state.textFormatting.main">{{change}}</h3></li>
                    </ul>                    
                    <h1 v-if="entry.major" :style="$store.state.textFormatting.main"> <b :style="$store.state.textFormatting.main"> Major </b> </h1>
                    <ul v-if="entry.major">
                        <li v-for="change in entry.major" :key="change" :style="$store.state.textFormatting.main"><h3 :style="$store.state.textFormatting.main">{{change}}</h3></li>
                    </ul>
                    <br v-if="entry.major" />
                    <h2 v-if="entry.minor" :style="$store.state.textFormatting.main"> <b :style="$store.state.textFormatting.main"> Minor </b> </h2>
                    <ul>
                        <li v-for="change in entry.minor" :key="change" :style="$store.state.textFormatting.main"><h3 :style="$store.state.textFormatting.main">{{change}}</h3></li>
                    </ul>

                </v-card-text>
            </v-card>
            <br />
        </v-flex>
    </v-container>
</template>

<script>

import info from '../../shared/operational/infopopout.vue';

export default {
  name: 'changelog',
  components: {
  },
  data () {
    return {
        changelog: [
            {
                'date':'Current Versions',
                'components' :[
                    'Web Frontend : V3.11',
                    'Ingest and Event Generation : V1.15',
                    'Event Analysis : V1.4',
                    'Email Alerting : V1.1',
                    'TraceRoute Schedulers : V1.1',
                    'TraceRoutes Workers : V1.0',
                    'Reference Data Collection (Registry) : V1.2',
                    'Reference Data Geo Aggregation (Registry) : V1.7',
                    'Reference Data Collection (Observed) : V1.60.8',
                    'Raw Data Downloads : V1.58',
                    'Polling API : V1.0',
                    'Infrastructure : V1.1 ',
                ]
            },
            {
                'date': '2022-03-31',
                'major': [
                    'Updates to User and Organisation Alerts pages',
                    'Updates to Legacy Restricted Prefixes to handle large numbers of rules',
                ],
                'minor': [
                    'Updates to Web Site to fix minor bugs',
                    'Updates to Database to accommodate changes',
                ]
            },
            {
                'date': '2022-02-08',
                'major': [
                    'Updates to User and Organisation Alerts pages',
                    'Updates to Traceroute Scheduler for Manual Traceroute feature',
                    'Updates to Alert Detail page to show Manual Traceroute feature',
                    'Restructuring of back-end analysis/alerting engines to improve scalability',
                ],
                'minor': [
                    'Updates to Web Site to fix minor bugs',
                    'Updates to Database to accommodate changes',
                ]
            },
            {
                'date': '2021-10-26',
                'major': [
                    'Addition of Alert Rules page',
                    'Updates to Alerting Engine to process new Rules',
                ],
                'minor': [
                    'Updates to Web Site to fix minor bugs',
                    'Updates to Ingest to improve stability',
                    'Updates to Database to accommodate changes',
                ]
            },
            {
                'date': '2021-05-26',
                'major': [
                    'Addition of chart to search results',
                    'Change to download feature in search results',
                    'Updates to Raw Data Download to accomodate search downloads',
                    'Updates to Database to accommodate changes and for performance',
                ],
                'minor': [
                    'Standardisation of time zone settings to UTC across site',
                    'Updates to Analytics engine to improve stability',
                    'Updates to Ingest to improve stability',
                    'Updates to Database to accommodate changes and for performance',
                ]
            },
            { 
                'date': '2021-03-08',
                'minor': [
                    'Introduced user and organisation alert filtering in Prefix and ASN settings',
                    'Introduced generic email fitering for intra-org asn assertions',
                    'Updates to improve stability and performance',
                ]
            },            
            { 
                'date': '2021-02-19',
                'minor': [
                    'Introduced user and organisation alert filtering for Intra-Organisation assertions',
                    'Updates to improve stability and performance',
                ]
            },
            { 
                'date': '2021-01-25',
                'minor': [
                    'Introduced alert Intra-Organisation Alert filtering toggle for Global View',
                    'Updates to improve stability and performance',
                ]
            },
            { 
                'date': '2020-12-14',
                'minor': [
                    'Fixed issue RIS Live feeds',
                    'Fixed the ability to inject dummy messages into RouteViews feeds between ingest phases',
                    'Added additional monitoring and metrics',
                ]
            },
            { 
                'date': '2020-11-27',
                'minor': [
                    'Fixed issue with Raw Data Download page that affected visibility and processing of requests',
                    'Fixed broken link to FAQ page',
                    'Added new sample script for Polling API usage',
                ]
            },
            { 
                'date': '2020-11-17',
                'minor': [
                    'Fixed minor issues from production release',
                    'Set default length of TopASNs list to 10',
                ]
            },
            { 
                'date': '2020-11-09',
                'major': [
                    'Launch of solution on new Production Platform',
                ]
            },
            { 
                'date': '2020-08-26',
                'minor': [
                    'Minor tweaks to performance throughout the system, caching of searches, enter key passthrough etc.',
                    'Better detail on info. boxes involving geogrpahical data.',
                    'Adjust ASN breakdown donut graph for better display.',
                    'Minor bugfixes',
                ]
            },
            { 
                'date': '2020-08-10',
                'minor': [
                    'Tooltips for edit / delete buttons in tables.',
                    'Zebra striped tables for easier viewing.',
                    'Other minor display tweaks, tooltips where previously should have been etc.',
                    'Settings for collapsing some objects is now stored centrally, with a view to add more object settings and have these stored centrally to persist across multiple devices/ browsers.',
                    'Auto-merge for \'Live Updates\' on user / organisation alerts pages.'

                ]
            },
            { 
                'date': '2020-07-30',
                'minor': [
                    'Fixed bug where ASNs were not editting upon changing too many variables at once.',
                    'Fixed bug where reviewed alerts were not appearing in the \'Organisation\' / \'User\' Alerts pages.',
                    'ASNs / Restricted Prefixes now export in format to be imported (why did we not think of this before!?).',
                    'Other minor fixes'
                ]
            },
            { 
                'date': '2020-07-20',
                'major': [
                    'Users can now enable email alerting, see the \'User Admin\' page. Here, the user can decide whether to receive emails for organisation and/or user alerts.'
                ],
                'minor': [
                    'Added \'delete all\' to user ASNs and restricted prefixes. This, used in conjunction with the CSV insert, can allow users to quickly adjust large groups of ASNs / prefixes.',
                    'When \'Edit\' is clicked on ASNs / prefixes page, the window will focus on the edit box.'
                ]
            },
            { 
                'date': '2020-07-15',
                'major': [
                    'Major change to the whole alerting system - please see the \'Edit ASNs\' and \'Edit Restricted Prefixes\' pages for details. To sum up in short: far more granular settings for alerting, with simple defaults for new users to the system.'
                ],
            },
            { 
                'date': '2020-06-26',
                'major': [
                    'Changes to the email alerts - adding a lot more clarity to each email, saving the need to visit the website in most cases'
                ],
            },
            { 
                'date': '2020-06-24',
                'major': [
                    'Bubble graph on User/Organisation Alerts page now persists when an ASN/ Prefix is selected on the left hand side.',
                    'Developer notes section included on Homepage - gives a brief summary of what we are developing towards.',
                    'FAQ page - please submit questions using the \'Feedback\' button and we can triage these to add more questions.',
                ],
                'minor': [
                    'Bug fixes',
                    'You can now add the same ASN multiple times with different settings'
                ]
            },
            { 
                'date': '2020-06-10',
                'major': [
                    'User/ Organisation Alerts now has the bubble graph from the executive summary included. It can also do auto-updating so you\'ll never have to leave the page.',
                ],
                'minor': [
                    'Many tweaks to the User/ Organisation Alerts pages, mostly QoL changes.',
                    'Homepage has additional text explaining the scoring system slightly more.',
                    'Full support throughout the page for BIGINT i.e. greater than 2^32 ASN numbers',
                    'General QoL changes, incorporation of additional parallel processing in many parts of the website.'
                ]
            },
            { 
                'date': '2020-05-20',
                'major': [
                    'Exec Summary disabled for live site',
                ]
            },
            { 
                'date': '2020-05-13',
                'major': [
                    'Released new, split version of \'User Alerts\', where it now shows organisation and user alerts separately.',
                    'This also displays a human readable version of what alert rules actually mean in relation to real life alerts.',
                ],
                'minor': [
                    'All alerts windows have been altered to have new, more efficient column ordering.',
                    'Search events\' columns can now be ordered, and reflect new column ordering',
                    'Update button on stats page',
                    'Changed timeestamp format on all pages, also timestamps should be localised'
                ]
            },
            { 
                'date': '2020-05-06',
                'major': [
                    'Tweaks to \'Executive Summary\', as well as addition of bubble chart. This shows alerts over time, with hijack score on the \'Y\' axis',
                ],
            },
            { 
                'date': '2020-05-04',
                'major': [
                    'New page: \'Executive Summary\'. This allows you to live monitor your organisation and summarises all incoming alerts by which prefix/ ASN they are involved with.',
                    'Alerts can be marked as reviewed from here, and the page requires no reloading to function fully. The idea being that you could leave this page open as an organisation dashboard',
                ],
                'minor': [
                    'Tweak to \'All\' traceroute to allow links to be seen for each traceroute',
                ]
            },
            { 
                'date': '2020-04-28',
                'major': [
                    'Search functionality should be working now, can be tempremental but works for around 5 hour windows for events or any time window for episodes. More tweaks still to come',
                ],
                'minor': [
                    'Bug fixes',
                ]
            },
            { 
                'date': '2020-04-24',
                'major': [
                    'Non-direct prefix is now displayed in all areas of the website. This is either the parent in the case of a subownership assertion, or child where we have a superownership assertion',
                ],
                'minor': [
                    'Tweaks to a few buttons',
                    'Bug fixes (including score breakdown - let me know if there are any discrepancies)',
                ]
            },
            { 
                'date': '2020-04-20',
                'major': [
                    'Cookie Policy / Privacy Notice (see bottom of page)',
                ],
                'minor': [
                    'Bug fixes',
                ]
            },
            { 
                'date': '2020-04-14',
                'major': [
                    'Re-introduced the Country ASNs page. Take a look to see which ASNs are partially/ fully in a given country.',
                    'Trialling new method of searching events, to improve reliability. Please trial it and give feedback'
                ],
                'minor': [
                    'Changed \'Dealt with\' to \'Reviewed\'',
                    'Added URL link column to alert when CSV is downloaded'
                ]
            },
            { 
                'date': '2020-03-30',
                'major': [
                    'ASN Baseline now shows currently advertised prefixes by an ASN, and compares these against reference data.',
                ],
            },
            { 
                'date': '2020-03-27',
                'major': [
                    'Alerts can now be marked as \'dealt with\'. They will no longer appear in your alert stream',
                ],
                'minor': [
                    'Check the info. boxes on \'User Alerts\' if it doesn\'t make sense, and please give feedback if it\'s not clear enough',
                ]
            },
            { 
                'date': '2020-03-26',
                'major': [
                    'Restricted prefixes are now as one column, independent of whether they are IPv4 or IPv6. Any hosts that were entered as both are now split in to 2 entries',
                ],
                'minor': [
                    'Display on alert clickthrough page altered',
                    'Queries on \'User ASNs\' page should be more efficient (please give feedback if not)',
                ]
            },
            { 
                'date': '2020-03-24',
                'major': [
                    'AS owner on hover - where an AS number is present on the website, in all prominent locations, it will now have the AS owner as a tooltip upon hovering over with the mouse',
                ],
                'minor': [
                    'Additional information on AS alerting thresholds and alerting mechanism on the \'User ASNs\' page',
                ]
            },
            { 
                'date': '2020-03-20',
                'major': [
                    'Optimisation for 4K screens complete (feedback welcome)',
                ],
            },
            { 
                'date': '2020-03-16',
                'major': [
                    'Optimisation for 4K screens in progress (see below)',
                ],
                'minor': [
                    'Now in place for homepage, user alerts page and alert clickthrough page. We welcome your early feedback on this while development is underway',
                    'All windows on the alert clickthrough page are now collapsible'
                ]
            },
            { 
                'date': '2020-03-11',
                'minor': [
                    'Tweaked menu colours on drop-down',
                    'ASN search on homepage can now be used with any ASN'
                ]
            },
            { 
                'date': '2020-03-10',
                'major': [
                    'Added recent alerts to alert clickthrough page (see top right above traceroute)',
                    'This show alerts in +-30 mins involving the ASN asserting ownership in that specific alert, including a summary per prefix'
                ],
                'minor': [
                    'Added colour scheme to the traceroute diagram'
                ]
            },
            { 
                'date': '2020-03-02',
                'major': [
                    'Added download for traceroute',
                ],
                'minor': [
                    'Fixed bug with links disappearing (but please let me know via \'Feedback\' if it does re-occur, as it\'s a work-around rather than a published fix)',
                    'Still awaiting adding in the colouring for unseen nodes'
                ]
            },
            { 
                'date': '2020-02-24 - 2020-02-28',
                'major': [
                    'Incorporated parallel traceroute results into the alert clickthrough page (see top right window after clicking on an alert)',
                ],
                'minor': [
                    'Known bug with the traceroute, where the links on the \'All\' node diagram may disappear, with the physics of them clearly working properly. I have contacted the creator of the plugin for a fix',
                    'Next up will be adding color scheme to the \'unseen\' nodes i.e. where they don\'t appear in the first traceroute'
                ]
            },
            { 
                'date': '2020-03-07',
                'major': [
                    'CSV Import of restricted prefixes - see "ADD PREFIX +" --> "CSV PREFIX ADD"',
                    'Similarly built in for ASNs - see "ADD ASN +" --> "CSV ASN ADD"',
                ],
                'minor': [
                    'CSV Download of user and organisation restricted prefixes',
                    'CSV Download of user and organisation ASNs'
                ]
            },
            { 
                'date': '2020-02-06',
                'major': [
                    'Initial launch of changelog',
                ],
                'minor': [
                    'Fixed bug with batch prefix submission',
                    'Altered sizing of columns & rows in user alerts tables',
                    'Validation step on prefix entry',
                ]
            },
            
        ],
    };
  },
  mounted () {
  },
  beforeMount() {  
  },
  methods: {
  }
};
</script>
